import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';
import { IconDescription } from '@noths/polaris-client-ribbons-design-system';

import * as copy from 'src/components/organisms/ProductDescription/constants/copy';
import { removeHtmlElementsFromString } from 'src/utils/removeHtmlElementFromString';
import * as styles from './ProductDescription.style';

export interface ProductDescriptionStateProps {
  description: string;
  dimensions?: string;
  ingredientsFileURLPath?: string;
  materials?: string;
  productCode: number;
  variationsAvailable?: string;
}

export interface ProductDescriptionDispatchProps {
  onVisible: () => void;
}

type ProductDescriptionProps = ProductDescriptionStateProps & ProductDescriptionDispatchProps;

interface SectionProps {
  heading: string;
  html: string;
}

const Section = ({ heading, html }: SectionProps) => {
  return (
    <>
      <h2 css={styles.heading}>{heading}</h2>
      <div
        dangerouslySetInnerHTML={{
          __html: removeHtmlElementsFromString(html, ['b', 'strong']),
        }}
      />
    </>
  );
};

export const ProductDescription = ({
  description,
  dimensions,
  ingredientsFileURLPath,
  materials,
  onVisible,
  productCode,
  variationsAvailable,
}: ProductDescriptionProps) => {
  const rootRef = useImpressionRef<HTMLDivElement>(() => onVisible());

  return (
    <div css={styles.wrapper} ref={rootRef}>
      <div css={styles.content}>
        <Section heading={copy.PRODUCT_DESCRIPTION_HEADING} html={description} />
        {variationsAvailable && (
          <Section heading={copy.PRODUCT_VARIATIONS_HEADING} html={variationsAvailable} />
        )}
      </div>
      <div css={styles.content}>
        {materials && <Section heading={copy.MADE_FROM_HEADING} html={materials} />}
        {dimensions && <Section heading={copy.PRODUCT_DIMENTIONS_HEADING} html={dimensions} />}
        {ingredientsFileURLPath && (
          <div css={styles.ingredientsInfo}>
            <div css={[styles.fileLinkWrapper]}>
              <IconDescription css={styles.fileIcon} height={16} width={16} />
              <a
                css={styles.fileLink}
                href={`https://cdn.notonthehighstreet.com${ingredientsFileURLPath}`}
                rel="noreferrer"
                target="_blank"
              >
                {copy.INGREDIENTS_TITLE}
              </a>
            </div>
          </div>
        )}
        <Section heading={copy.PRODUCT_CODE_HEADING} html={`<p>${productCode}</p>`} />
      </div>
    </div>
  );
};
